import React from 'react';
import Button from './Button';
import GettonciniCostChip from './GettonciniCostChip';
import { REWARDED_VIEW_STATES, useRewardedGettonciniAd } from '../hooks/useRewardedGettonciniAd';
import styles from '../styles/RewardedGettonciniCard.module.css';

const RewardedGettonciniCard = ({
  sourceSurface,
  gameSlug = null,
  compact = false,
  className = '',
  authNextPath = null,
  signedOutGateReason = null,
  signedOutMessage = null,
}) => {
  const {
    cooldownProgressPercent,
    handleAuthClick,
    handleCtaClick,
    inventoryBlockReason,
    isLoadingStatus,
    isSignedIn,
    remainingDailyClaims,
    rewardAmount,
    viewState,
  } = useRewardedGettonciniAd({
    sourceSurface,
    gameSlug,
    authNextPath,
    signedOutGateReason,
    signedOutMessage,
  });

  const canWatchNow = isSignedIn
    && viewState === REWARDED_VIEW_STATES.IDLE_READY
    && !inventoryBlockReason;

  const ctaLabel = (() => {
    if (!isSignedIn) {
      return 'Accedi';
    }
    if (viewState === REWARDED_VIEW_STATES.PLAYING) {
      return 'Annuncio in corso';
    }
    if (viewState === REWARDED_VIEW_STATES.LOADING_AD) {
      return 'Caricamento...';
    }
    if (viewState === REWARDED_VIEW_STATES.COOLDOWN) {
      return 'Attendi';
    }
    if (viewState === REWARDED_VIEW_STATES.CAPPED_OR_UNAVAILABLE) {
      return remainingDailyClaims > 0 ? 'Non disponibile ora' : 'Limite raggiunto';
    }
    return 'Guarda un annuncio';
  })();

  const ctaClassName = [
    styles.cta,
    canWatchNow ? styles.ctaReady : '',
    viewState === REWARDED_VIEW_STATES.COOLDOWN ? styles.ctaCooldown : '',
    viewState === REWARDED_VIEW_STATES.CAPPED_OR_UNAVAILABLE ? styles.ctaUnavailable : '',
  ].filter(Boolean).join(' ');

  const ctaStyle = viewState === REWARDED_VIEW_STATES.COOLDOWN
    ? { '--rewarded-cooldown-progress': `${cooldownProgressPercent}%` }
    : undefined;

  return (
    <div
      className={[
        styles.root,
        compact ? styles.compactRoot : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      <Button
        primary={canWatchNow}
        secondary={!isSignedIn}
        className={ctaClassName}
        onClick={isSignedIn ? handleCtaClick : handleAuthClick}
        disabled={isSignedIn && !canWatchNow}
        loading={isSignedIn && (viewState === REWARDED_VIEW_STATES.LOADING_AD || isLoadingStatus)}
        loadingText={ctaLabel}
        style={ctaStyle}
      >
        <span className={styles.ctaContent}>
          <span>{ctaLabel}</span>
        </span>
      </Button>
      {isSignedIn && rewardAmount ? (
        <GettonciniCostChip
          amount={rewardAmount}
          direction="earn"
          compact
          className={styles.ctaChip}
        />
      ) : null}
    </div>
  );
};

export default RewardedGettonciniCard;
